module.exports = __webpack_public_path__ + "static/media/arrow-back.85f6a9ca.svg";